<div class="flex flex-col gap-1 p-4 bg-(--color-bg-primary) rounded-lg min-w-0">
  <span class="text-xs font-semibold uppercase tracking-wider text-(--color-text-muted)">{{ title() }}</span>
  <span class="text-2xl font-extrabold leading-tight tracking-tight" [class]="{
    'text-(--color-primary)': valueColor() === 'primary',
    'text-emerald-600': valueColor() === 'success',
    'text-(--color-text-warning)': valueColor() === 'warning',
    'text-(--color-text-error)': valueColor() === 'danger',
    'text-(--color-text-secondary)': valueColor() === 'muted'
  }">{{ value() }}</span>
  @if (description()) {
    <span class="text-sm font-semibold text-(--color-text-secondary) mt-0.5">{{ description() }}</span>
  }
</div>
